import React from 'react';
import type { Widget } from 'App/components/hooks/integrations/externalIntegrationTypes';
import './UiWidget.scss';
import UiWidgetComponent from './UiWidgetComponent';
import useDataSources from './useDataSources';
import type { Order, FieldActions } from 'App/resources/Model/Order';

interface UiWidgetProps {
	widget: Widget;
	updateOrderFromApp?: (fieldActions: FieldActions, order?: Order) => void;
	dataSources?: Record<string, any>;
	settings?: Record<string, any>;
}

const UiWidget = ({
	widget,
	updateOrderFromApp,
	dataSources: propDataSources,
	settings: propSettings
}: UiWidgetProps) => {
	const hookResult = useDataSources(
		widget.externalId,
		propDataSources !== undefined ? undefined : widget.settings?.dataSource
	);

	const dataSources = propDataSources !== undefined ? propDataSources : hookResult.dataSources;
	const settings = propSettings !== undefined ? propSettings : hookResult.settings;

	if (!Array.isArray(widget.widgetRows)) return null;

	return (
		<div className="UiWidget">
			{widget.widgetRows.map((row, idx) => {
				return (
					<UiWidgetComponent
						key={`UiWidget-${row.id}-${idx}`}
						row={row}
						widgetExternalId={widget.externalId}
						dataSources={dataSources}
						widgetSettings={settings}
						widgetType={widget.type}
						updateOrderFromApp={updateOrderFromApp}
						dataSourceSettings={widget.settings?.dataSource}
					/>
				);
			})}
		</div>
	);
};

export default UiWidget;
